import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faUsers,
  faClock,
  faHouse,
  faNoteSticky,
} from "@fortawesome/free-solid-svg-icons";
import { DefaultDateSmall } from "../components/DefaultImports";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  overflow: hidden;
  border-radius: 25px;
`;

const Step = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ active, completed }) =>
    active || completed ? "#EE754C" : "#f2f2f2"};
  color: ${({ active, completed }) =>
    active || completed ? "white" : "#a0a0a0"};
  font-weight: 500;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  position: relative;
  padding: 4px 6px;
  text-align: center;
  font-size: 11px;
  transition: all 0.3s ease;
  min-width: 0;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    right: -8px;
    top: 0;
    width: 0;
    height: 0;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 8px solid
      ${({ active, completed }) =>
        active || completed ? "#EE754C" : "#f2f2f2"};
    z-index: 1;
  }

  &:first-child {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }

  &:last-child {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  .step-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }

  .step-icon {
    font-size: 13px;
    margin-bottom: 2px;
  }

  .step-text {
    font-size: 11px;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
    white-space: nowrap;
  }

  .step-subtext {
    font-size: 10px;
    line-height: 1;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 90%;
  }
`;

const StepperComponent = ({
  startDate = "",
  numPeople = "",
  time = "",
  placeOfTable = "",
  changeStep,
  currentStep,
  reservation_or_waiting_list,
  timezone,
  from_restaurant,
}) => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    { icon: faCalendarAlt, label: "Data" },
    { icon: faUsers, label: "Pessoas" },
    {
      icon: reservation_or_waiting_list === "reservation" ? faClock : faHouse,
      label: "Horas e Sala",
    },
    { icon: faNoteSticky, label: "Informações" },
  ];

  useEffect(() => {
    setActiveStep(currentStep);
  }, [currentStep]);

  const getDateInTimezone = () => {
    const now = new Date();
    const dateInTimezone = new Date(
      now.toLocaleString("en-US", { timeZone: timezone })
    );
    dateInTimezone.setHours(0, 0, 0, 0);
    return dateInTimezone;
  };

  const getLabelForDate = () => {
    const today = getDateInTimezone();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const date = new Date(startDate);
    date.setHours(0, 0, 0, 0);

    if (date.getTime() === today.getTime()) return "Hoje";
    if (date.getTime() === tomorrow.getTime()) return "Amanhã";
    return <DefaultDateSmall date={date} />;
  };

  const getStepText = (step) => {
    if (step.label === "Data" && startDate) return getLabelForDate();
    if (step.label === "Pessoas" && numPeople)
      return `${numPeople} ${numPeople === 1 ? "Pessoa" : "Pessoas"}`;
    if (step.label === "Horas e Sala" && time) {
      return time;
    }
    return step.label;
  };

  const getStepSubText = () => {
    const trimmedPlace =
      placeOfTable.length > 18
        ? `${placeOfTable.substring(0, 18)}...`
        : placeOfTable.endsWith("/f")
        ? placeOfTable.slice(0, -2)
        : placeOfTable;
    return trimmedPlace;
  };

  const handleClick = (index) => {
    if (index <= activeStep || from_restaurant) {
      if (!(reservation_or_waiting_list === "waiting_list" && index === 0)) {
        setActiveStep(index);
        changeStep(index);
      }
    }
  };

  return (
    <Container>
      {steps.map((step, index) => (
        <Step
          key={index}
          active={index === activeStep}
          completed={index < activeStep}
          clickable={index <= activeStep || from_restaurant}
          onClick={() => handleClick(index)}
        >
          <div className="step-content">
            <FontAwesomeIcon icon={step.icon} className="step-icon" />
            <span className="step-text">{getStepText(step)}</span>
            {step.label === "Horas e Sala" && time && (
              <span className="step-subtext" title={placeOfTable}>
                {getStepSubText()}
              </span>
            )}
          </div>
        </Step>
      ))}
    </Container>
  );
};

export default StepperComponent;
